import api from '../../services/api';
import { Creators } from '../ducks/product_detail';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getProductsDetail({ filter }) {
  try {

    yield put(Creators.productDetailRequest());
    const response = yield call(api.post, 'product-detail', filter);

    yield put(Creators.productDetailSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.productDetailError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao listar detalhe de produtos'
    }));
  }
}